import { Business, CardBuy } from "models/business.model";

export const SAMPLE_BUSINESS_DATA: Business[] = [
  {
    id: "65e58b4fbf55d741f6527718",
    regNumber: "1158603263",
    name: "업체 01-01",
    incharge: "",
    completedDataNumber: 5,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 5,
    isAccountingConfirmed: false,
  },
  {
    id: "63d1f6b431bf81120cedc66a",
    regNumber: "2678802725",
    name: "업체 01-02",
    incharge: "",
    completedDataNumber: 80,
    newzenTransferredDataNumber: 40,
    totalDataNumber: 86,
    isAccountingConfirmed: false,
  },
  {
    id: "66deb25b830e03566362de8d",
    regNumber: "4348101782",
    name: "업체 01-03",
    incharge: "",
    completedDataNumber: 123,
    newzenTransferredDataNumber: 120,
    totalDataNumber: 123,
    isAccountingConfirmed: false,
  },
  {
    id: "65af6b003796831bf59d94bc",
    regNumber: "5648102684",
    name: "업체 01-04",
    incharge: "",
    completedDataNumber: 52,
    newzenTransferredDataNumber: 25,
    totalDataNumber: 52,
    isAccountingConfirmed: false,
  },
  {
    id: "6350ae10545bfb2ca746c5ca",
    regNumber: "7588100525",
    name: "업체 01-05",
    cluster: "서비스",
    subCluster: "소프트웨어 자문, 개발 및 공급업",
    incharge: "",
    completedDataNumber: 35,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 35,
    isAccountingConfirmed: false,
  },
  {
    id: "6666eea0acbde13e901e9355",
    regNumber: "4478103108",
    name: "업체 01-06",
    cluster: "전문 과학 및 기술 서비스업",
    subCluster: "융합 연구개발업",
    incharge: "",
    completedDataNumber: 9,
    newzenTransferredDataNumber: 9,
    totalDataNumber: 9,
    isAccountingConfirmed: false,
  },
  {
    id: "6646d57fa9fdc352360e5234",
    regNumber: "4048703118",
    name: "업체 01-07",
    cluster: "정보통신업",
    subCluster: "응용 소프트웨어 개발 및 공급업",
    incharge: "",
    completedDataNumber: 4,
    newzenTransferredDataNumber: 4,
    totalDataNumber: 4,
    isAccountingConfirmed: false,
  },
  {
    id: "65fa86b4e2c1c432b99e1da0",
    regNumber: "3798101656",
    name: "업체 01-08",
    cluster: "서비스업",
    subCluster: "매니저업",
    incharge: "",
    completedDataNumber: 85,
    newzenTransferredDataNumber: 20,
    totalDataNumber: 85,
    isAccountingConfirmed: false,
  },
  {
    id: "668b8e745938b27fa601b321",
    regNumber: "1818702287",
    name: "업체 01-09",
    incharge: "",
    completedDataNumber: 0,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 35,
    isAccountingConfirmed: false,
  },
  {
    id: "656d9012e5112300eab5f805",
    regNumber: "4208603068",
    name: "업체 01-10",
    cluster: "정보통신업, 도매 및 소매업, 정보통신업",
    subCluster:
      "응용 소프트웨어 개발 및 공급업, 전자상거래 소매업, 시스템 소프트웨어 개발 및 공급업 ",
    incharge: "",
    completedDataNumber: 32,
    newzenTransferredDataNumber: 32,
    totalDataNumber: 32,
    isAccountingConfirmed: false,
  },
  {
    id: "649ce1f3b8a1da192bfe09dc",
    regNumber: "3318602584",
    name: "업체 01-11",
    incharge: "",
    completedDataNumber: 20,
    newzenTransferredDataNumber: 20,
    totalDataNumber: 34,
    isAccountingConfirmed: false,
  },
  {
    id: "633404bc555ef56e1c6f14f6",
    regNumber: "5318702707",
    name: "업체 01-12",
    cluster: "제조업",
    subCluster: "252909",
    incharge: "",
    completedDataNumber: 46,
    newzenTransferredDataNumber: 10,
    totalDataNumber: 46,
    isAccountingConfirmed: false,
  },
  {
    id: "66350165af918638a35ef936",
    regNumber: "8038703047",
    name: "업체 01-13",
    cluster: "정보통신업",
    subCluster: "응용 소프트웨어 개발 및 공급업",
    incharge: "",
    completedDataNumber: 35,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 35,
    isAccountingConfirmed: false,
  },
  {
    id: "633648135391a63836158e35",
    regNumber: "4068700868",
    name: "업체 01-14",
    cluster: "서비스",
    subCluster: "데이터베이스 및 온라인정보제공",
    incharge: "",
    completedDataNumber: 320,
    newzenTransferredDataNumber: 200,
    totalDataNumber: 373,
    isAccountingConfirmed: false,
  },
  {
    id: "646d35694e8af11d3b410bf2",
    regNumber: "6558602404",
    name: "업체 01-15",
    incharge: "",
    completedDataNumber: 55,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 55,
    isAccountingConfirmed: false,
  },
  {
    id: "654de2288c599c267a068669",
    regNumber: "6818103197",
    name: "업체 01-16",
    incharge: "",
    completedDataNumber: 22,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 22,
    isAccountingConfirmed: false,
  },
  {
    id: "64740dd7534bb3733e730c16",
    regNumber: "7898702271",
    name: "업체 01-17",
    cluster: "서비스",
    subCluster: "건축사",
    incharge: "",
    completedDataNumber: 16,
    newzenTransferredDataNumber: 16,
    totalDataNumber: 16,
    isAccountingConfirmed: false,
  },
  {
    id: "63200f2b88d1fc1abf9e3048",
    regNumber: "1548602406",
    name: "업체 01-18",
    incharge: "",
    completedDataNumber: 112,
    newzenTransferredDataNumber: 68,
    totalDataNumber: 112,
    isAccountingConfirmed: false,
  },
  {
    id: "65f29144bc5c5901b4b69903",
    regNumber: "1968703162",
    name: "업체 01-19",
    cluster: "정보통신업, 도매 및 소매업",
    subCluster: "소프트웨어 개발 및 공급업, 전자상거래",
    incharge: "",
    completedDataNumber: 3,
    newzenTransferredDataNumber: 3,
    totalDataNumber: 3,
    isAccountingConfirmed: false,
  },
  {
    id: "632d623497f12661b7d144b3",
    regNumber: "3798602761",
    name: "업체 01-20",
    incharge: "",
    completedDataNumber: 38,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 38,
    isAccountingConfirmed: false,
  },
  {
    id: "66c69de127a9aa49f20f21e0",
    regNumber: "8458603160",
    name: "업체 01-21",
    cluster: "",
    subCluster: "",
    incharge: "",
    completedDataNumber: 48,
    newzenTransferredDataNumber: 40,
    totalDataNumber: 48,
    isAccountingConfirmed: false,
  },
  {
    id: "6584570611305364d88b775c",
    regNumber: "2028603058",
    name: "업체 01-22",
    incharge: "",
    completedDataNumber: 12,
    newzenTransferredDataNumber: 12,
    totalDataNumber: 12,
    isAccountingConfirmed: false,
  },
  {
    id: "6270f4577d0d254b5ef41860",
    regNumber: "3058701166",
    name: "업체 01-23",
    cluster: "부동산업",
    subCluster: "전대업",
    incharge: "",
    completedDataNumber: 29,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 29,
    isAccountingConfirmed: false,
  },
  {
    id: "6487c357a2b2100b11a72fb1",
    regNumber: "4368602609",
    name: "업체 01-24",
    incharge: "",
    completedDataNumber: 172,
    newzenTransferredDataNumber: 172,
    totalDataNumber: 172,
    isAccountingConfirmed: false,
  },
  {
    id: "65b20ca6163ac6318e462b18",
    regNumber: "3998703155",
    name: "업체 01-25",
    cluster: "서비스",
    subCluster: "광고",
    incharge: "",
    completedDataNumber: 164,
    newzenTransferredDataNumber: 40,
    totalDataNumber: 164,
    isAccountingConfirmed: false,
  },
  {
    id: "668f446f5938b27fa609de40",
    regNumber: "5220203345",
    name: "업체 01-26",
    cluster: "정보통신업",
    subCluster: "응용 소프트웨어 개발 및 공급업",
    incharge: "",
    completedDataNumber: 0,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 29,
    isAccountingConfirmed: false,
  },
  {
    id: "631d3df38cecb44a546c571f",
    regNumber: "8948602635",
    name: "업체 01-27",
    cluster: "제조업",
    subCluster: "기타 반도체 소자 제조업",
    incharge: "",
    completedDataNumber: 37,
    newzenTransferredDataNumber: 28,
    totalDataNumber: 37,
    isAccountingConfirmed: false,
  },
  {
    id: "65d359eae9b91d3adb387f20",
    regNumber: "2968103290",
    name: "업체 01-28",
    cluster: "정보통신업,도매및소매업,전문,과학및 기술서비스업",
    subCluster: "응용 소프트웨어 개발 및 공급업,소프트웨어 관련 컨설팅업등",
    incharge: "",
    completedDataNumber: 7,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 7,
    isAccountingConfirmed: false,
  },
  {
    id: "633bbce3f995481e5f55f2e1",
    regNumber: "6598602589",
    name: "업체 01-29",
    incharge: "",
    completedDataNumber: 55,
    newzenTransferredDataNumber: 44,
    totalDataNumber: 55,
    isAccountingConfirmed: false,
  },
  {
    id: "65250ae5d24f817ccdf04558",
    regNumber: "5878702864",
    name: "업체 01-30",
    incharge: "",
    completedDataNumber: 11,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 11,
    isAccountingConfirmed: false,
  },
  {
    id: "65fb929ae2c1c432b99ff8fd",
    regNumber: "1188603132",
    name: "업체 01-31",
    incharge: "",
    completedDataNumber: 18,
    newzenTransferredDataNumber: 18,
    totalDataNumber: 18,
    isAccountingConfirmed: false,
  },
  {
    id: "664ef02008354064d5c46d62",
    regNumber: "5498703162",
    name: "업체 01-32",
    cluster: "정보통신업",
    subCluster: "응용 소프트웨어 개발 및 공급업",
    incharge: "",
    completedDataNumber: 46,
    newzenTransferredDataNumber: 11,
    totalDataNumber: 46,
    isAccountingConfirmed: false,
  },
  {
    id: "656048528d6839181ab34a0d",
    regNumber: "1928802950",
    name: "소프티오닉스",
    cluster: "전문, 과학 및 기술서비스업",
    subCluster: "전기,전자공학 연구개발업",
    incharge: "",
    completedDataNumber: 11,
    newzenTransferredDataNumber: 10,
    totalDataNumber: 21,
    isAccountingConfirmed: false,
  },
  {
    id: "66e0f606670b016754bf06ee",
    regNumber: "1918800449",
    name: "스튜디오달감 주식회사",
    cluster: "서비스업",
    subCluster: "방송제작",
    incharge: "",
    completedDataNumber: 135,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 135,
    isAccountingConfirmed: false,
  },
  {
    id: "6662e996c91cce03f64744df",
    regNumber: "5730502836",
    name: "아이노헬스케어",
    cluster: "정보통신업",
    subCluster: "응용 소프트웨어 개발 및 공급업업",
    incharge: "",
    completedDataNumber: 5,
    newzenTransferredDataNumber: 5,
    totalDataNumber: 5,
    isAccountingConfirmed: false,
  },
  {
    id: "633beac0f995481e5f56f5f8",
    regNumber: "3061364580",
    name: "에스엠코오퍼레이션 파주",
    cluster: "소매",
    subCluster: "시계",
    incharge: "",
    completedDataNumber: 36,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 36,
    isAccountingConfirmed: false,
  },
  {
    id: "653f4be09aed620ae7df573b",
    regNumber: "2988802753",
    name: "에이에스이티",
    cluster: "제조업",
    subCluster: "축전지 제조업",
    incharge: "",
    completedDataNumber: 93,
    newzenTransferredDataNumber: 50,
    totalDataNumber: 93,
    isAccountingConfirmed: false,
  },
  {
    id: "64781a04711b7e00312350f4",
    regNumber: "1448138601",
    name: "에이트스튜디오(주)",
    cluster: "정보통신업",
    subCluster: "응용소프트웨어 개발 및 공급업",
    incharge: "",
    completedDataNumber: 76,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 76,
    isAccountingConfirmed: false,
  },
  {
    id: "651d8117c2f95a265fe85cb0",
    regNumber: "8578703030",
    name: "에코이츠 주식회사",
    incharge: "",
    completedDataNumber: 16,
    newzenTransferredDataNumber: 16,
    totalDataNumber: 16,
    isAccountingConfirmed: false,
  },
  {
    id: "65a3ef5ec9b7fe50b4f2f211",
    regNumber: "4428102332",
    name: "에코코스 주식회사",
    cluster: "도매 및 소매업",
    subCluster: "화장품, 비누 및 방향제 소매업",
    incharge: "",
    completedDataNumber: 35,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 35,
    isAccountingConfirmed: false,
  },
  {
    id: "66cd792b9573631cffe91b65",
    regNumber: "4858703363",
    name: "엑소반도체 주식회사",
    cluster: "제조업",
    subCluster: "기타 반도체 소자 제조업",
    incharge: "",
    completedDataNumber: 4,
    newzenTransferredDataNumber: 4,
    totalDataNumber: 4,
    isAccountingConfirmed: false,
  },
  {
    id: "65a5f404b25eab23831e0599",
    regNumber: "4038602351",
    name: "엔바이오셀 주식회사",
    cluster: "제조업",
    subCluster: "화장품원료",
    incharge: "",
    completedDataNumber: 15,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 15,
    isAccountingConfirmed: false,
  },
  {
    id: "66023900e2c1c432b9abc84a",
    regNumber: "7118702695",
    name: "여기우리 주식회사",
    cluster: "",
    subCluster: "",
    incharge: "",
    completedDataNumber: 158,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 158,
    isAccountingConfirmed: false,
  },
  {
    id: "663de18ea9fdc3523608f4ae",
    regNumber: "5228502655",
    name: "옥된장 구로디지털점",
    cluster: "숙박 및 음식점업",
    subCluster: "한식 일반 음식점업",
    incharge: "",
    completedDataNumber: 104,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 104,
    isAccountingConfirmed: false,
  },
  {
    id: "65f7d980e2c1c432b995f7ba",
    regNumber: "2978103594",
    name: "와이즈넥서스",
    cluster: "",
    subCluster: "",
    incharge: "",
    completedDataNumber: 71,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 71,
    isAccountingConfirmed: false,
  },
  {
    id: "66667650c91cce03f649ba8d",
    regNumber: "5302801450",
    name: "와이즈영특허사무소",
    cluster: "변리업",
    subCluster: "변리업",
    incharge: "",
    completedDataNumber: 9,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 9,
    isAccountingConfirmed: false,
  },
  {
    id: "632d224897f12661b7d1315b",
    regNumber: "2098601478",
    name: "우기",
    incharge: "",
    completedDataNumber: 34,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 34,
    isAccountingConfirmed: false,
  },
  {
    id: "633e8e1d2081d904e99bc804",
    regNumber: "1098647835",
    name: "원엔터테인먼트",
    cluster: "서비스",
    subCluster: "방송프로그램제작업",
    incharge: "",
    completedDataNumber: 78,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 78,
    isAccountingConfirmed: false,
  },
  {
    id: "6645cf29af918638a370e61e",
    regNumber: "5978103586",
    name: "원포인트스트래티지",
    cluster: "교육서비스업",
    subCluster: "경영 컨설팅업",
    incharge: "",
    completedDataNumber: 57,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 57,
    isAccountingConfirmed: false,
  },
  {
    id: "66c6cb4f9573631cffd7e67b",
    regNumber: "6308703696",
    name: "웨스컴",
    cluster: "정보통신업",
    subCluster: "응용 소프트웨어 개발 및 공급업",
    incharge: "",
    completedDataNumber: 106,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 106,
    isAccountingConfirmed: false,
  },
  {
    id: "66287ca9a9fdc35236dfbb5a",
    regNumber: "1588703423",
    name: "웨이브다인",
    cluster: "전문, 과학 및 기술서비스업",
    subCluster: "전지전자공학 연구개발업",
    incharge: "",
    completedDataNumber: 38,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 38,
    isAccountingConfirmed: false,
  },
  {
    id: "647fef2e711b7e0031284ace",
    regNumber: "4528103172",
    name: "유앤티 주식회사",
    cluster: "정보통신업",
    subCluster: "컴퓨터 및 주변장치, 소프트웨어 도소매업",
    incharge: "",
    completedDataNumber: 48,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 48,
    isAccountingConfirmed: false,
  },
  {
    id: "657bda5327c23e657593a276",
    regNumber: "2618105818",
    name: "유한회사 페이버릿미디엄",
    incharge: "",
    completedDataNumber: 19,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 19,
    isAccountingConfirmed: false,
  },
  {
    id: "65438b536471cb297645d564",
    regNumber: "3808702962",
    name: "주식회사 기억상회",
    cluster: "도매 및 소매업 제조업 정보통신업",
    subCluster: "안경테 선글라스 전자상거래업",
    incharge: "",
    completedDataNumber: 24,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 24,
    isAccountingConfirmed: false,
  },
  {
    id: "648656a5a2b2100b11a58bb5",
    regNumber: "1518103231",
    name: "주식회사 나인스원더",
    incharge: "",
    completedDataNumber: 169,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 169,
    isAccountingConfirmed: false,
  },
  {
    id: "65536bae49e59c357302dfc0",
    regNumber: "3798702832",
    name: "주식회사 뉴지엄랩",
    incharge: "",
    completedDataNumber: 13,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 13,
    isAccountingConfirmed: false,
  },
  {
    id: "6670ce0c46379f609bb17d50",
    regNumber: "3448603105",
    name: "주식회사 다이버시티",
    cluster: "전문, 과학 및 기술 서비스업",
    subCluster: "경영 컨설팅업",
    incharge: "",
    completedDataNumber: 57,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 57,
    isAccountingConfirmed: false,
  },
  {
    id: "63ec857f7e7892157185e8d6",
    regNumber: "2248802524",
    name: "주식회사 더다오스",
    cluster: "전문, 과학 및 기술서비스업",
    subCluster: "경영 컨설팅업",
    incharge: "",
    completedDataNumber: 2,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 2,
    isAccountingConfirmed: false,
  },
  {
    id: "64e836007afe1c0a8f0db34f",
    regNumber: "6628802726",
    name: "주식회사 더블유와이피코리아",
    cluster:
      "협회 및 단체, 수리 및 기타 개인서비스업 정보통신업 정보통신업 전문, 과학 및 기술 서비스업 전문, 과학 및 기술서비스업 전문, 과학 및 기술서비스업",
    subCluster:
      "결혼 상담 및 준비 서비스업 응용 소프트웨어 개발 및 공급업 시스템 소프트웨어 개발 및 공급업 경영 컨설팅업 광고 대행업 그 외 기타 광고 관련 서비스업",
    incharge: "",
    completedDataNumber: 101,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 101,
    isAccountingConfirmed: false,
  },
  {
    id: "657c165827c23e6575942880",
    regNumber: "1088617527",
    name: "주식회사 데브레인",
    cluster: "정보통신업",
    subCluster: "소프트웨어 개발 및 공급업",
    incharge: "",
    completedDataNumber: 7,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 7,
    isAccountingConfirmed: false,
  },
  {
    id: "66f2326834e38b00c94d94bb",
    regNumber: "6948603709",
    name: "주식회사 동성과학",
    cluster: "",
    subCluster: "",
    incharge: "",
    completedDataNumber: 1,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 1,
    isAccountingConfirmed: false,
  },
  {
    id: "6488002e9718485b563b1fb7",
    regNumber: "6868702123",
    name: "주식회사 루미글루",
    incharge: "",
    completedDataNumber: 95,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 95,
    isAccountingConfirmed: false,
  },
  {
    id: "64c22d9e7a7ba173dc0059d2",
    regNumber: "6658602814",
    name: "주식회사 룰메이커스",
    incharge: "",
    completedDataNumber: 142,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 142,
    isAccountingConfirmed: false,
  },
  {
    id: "6321451d5a02fe1fdc1bed75",
    regNumber: "8818802685",
    name: "주식회사 마크온쏘울",
    cluster: "전문, 과학 및 기술서비스업",
    subCluster: "광고 대행업",
    incharge: "",
    completedDataNumber: 194,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 194,
    isAccountingConfirmed: false,
  },
  {
    id: "6479e1ee711b7e00312639b3",
    regNumber: "2648702694",
    name: "주식회사 메타파머스",
    incharge: "",
    completedDataNumber: 47,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 47,
    isAccountingConfirmed: false,
  },
  {
    id: "6485fd129718485b5637a2fb",
    regNumber: "3558802774",
    name: "주식회사 무븐트",
    cluster: "정보통신업",
    subCluster: "시스템 소프트웨어 개발 및 공급업",
    incharge: "",
    completedDataNumber: 75,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 75,
    isAccountingConfirmed: false,
  },
  {
    id: "66430ff6a9fdc352360c33a7",
    regNumber: "1588603300",
    name: "주식회사 미피아",
    incharge: "",
    completedDataNumber: 9,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 9,
    isAccountingConfirmed: false,
  },
  {
    id: "651fbb03c2f95a265fec2112",
    regNumber: "6128155627",
    name: "주식회사 바이너리컬",
    cluster: "정보통신업",
    subCluster: "응용 소프트웨어 개발 및 공급업",
    incharge: "",
    completedDataNumber: 11,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 11,
    isAccountingConfirmed: false,
  },
  {
    id: "6481ced4a2b2100b11a3cf1d",
    regNumber: "6798602171",
    name: "주식회사 바이트컴퍼니",
    incharge: "",
    completedDataNumber: 106,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 106,
    isAccountingConfirmed: false,
  },
  {
    id: "63b6824c917d0968c12ffd1f",
    regNumber: "3618601567",
    name: "주식회사 버그홀",
    cluster: "도매 및 소매업",
    subCluster: "전자상거래업",
    incharge: "",
    completedDataNumber: 149,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 149,
    isAccountingConfirmed: false,
  },
  {
    id: "65603aaae5112300ea9f0282",
    regNumber: "6858602346",
    name: "주식회사 병원사람들",
    incharge: "",
    completedDataNumber: 33,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 33,
    isAccountingConfirmed: false,
  },
  {
    id: "6262087dd5e7cd70aed38657",
    regNumber: "8228701977",
    name: "주식회사 브리피",
    cluster: "정보통신업",
    subCluster: "응용 소프트웨어 개발 및 공급업",
    incharge: "",
    completedDataNumber: 304,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 304,
    isAccountingConfirmed: false,
  },
  {
    id: "62ea1a348d6c8e1270ddacb0",
    regNumber: "2118897063",
    name: "주식회사 비씨앤컴퍼니",
    cluster: "서비스",
    subCluster: "의료소프트웨어 개발 및 관리",
    incharge: "",
    completedDataNumber: 87,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 87,
    isAccountingConfirmed: false,
  },
  {
    id: "65d2c84de9b91d3adb37456d",
    regNumber: "3648703033",
    name: "주식회사 사각코퍼레이션",
    cluster: "도매 및 소매업",
    subCluster: "전자상거래 소매업",
    incharge: "",
    completedDataNumber: 189,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 189,
    isAccountingConfirmed: false,
  },
  {
    id: "63a2ba518e80d0087e768cad",
    regNumber: "3018801079",
    name: "주식회사 샘컨설팅",
    incharge: "",
    completedDataNumber: 15,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 15,
    isAccountingConfirmed: false,
  },
  {
    id: "66a8739384c62040f15ef65d",
    regNumber: "2988103146",
    name: "주식회사 소울캔버스",
    cluster: "정보통신업",
    subCluster: "응용소프트웨어 개발 및 공급업",
    incharge: "",
    completedDataNumber: 11,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 11,
    isAccountingConfirmed: false,
  },
  {
    id: "64d05498b15fb60365970110",
    regNumber: "8018602991",
    name: "주식회사 솔버사피엔스",
    cluster: "정보통신업",
    subCluster: "응용 소프트웨어 개발 및 공급업",
    incharge: "",
    completedDataNumber: 26,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 26,
    isAccountingConfirmed: false,
  },
  {
    id: "65d92106cd706c52e1f4ab7c",
    regNumber: "5038621094",
    name: "주식회사 아날로그에이아이",
    incharge: "",
    completedDataNumber: 16,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 16,
    isAccountingConfirmed: false,
  },
  {
    id: "66cfa5039573631cfff4dde4",
    regNumber: "5848603343",
    name: "주식회사 아로빈스",
    cluster: "정보통신업",
    subCluster: "응용 소프트웨어 개발 및 공급업",
    incharge: "",
    completedDataNumber: 22,
    newzenTransferredDataNumber: 22,
    totalDataNumber: 22,
    isAccountingConfirmed: false,
  },
  {
    id: "6323fda7455aa24c364c6964",
    regNumber: "2208783061",
    name: "주식회사 아이엠폼",
    incharge: "",
    completedDataNumber: 181,
    newzenTransferredDataNumber: 11,
    totalDataNumber: 181,
    isAccountingConfirmed: false,
  },
  {
    id: "662a37eba9fdc35236e72498",
    regNumber: "1638103291",
    name: "주식회사 아쿠온",
    incharge: "",
    completedDataNumber: 26,
    newzenTransferredDataNumber: 26,
    totalDataNumber: 26,
    isAccountingConfirmed: false,
  },
  {
    id: "65bb160cc339714c8b637ee2",
    regNumber: "2808103446",
    name: "주식회사 앱티마이저",
    cluster: "정보통신업",
    subCluster: "적성관련 인공지능 학습용 데이터 구축 및 컨설팅 서비스업",
    incharge: "",
    completedDataNumber: 33,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 33,
    isAccountingConfirmed: false,
  },
  {
    id: "6476d9adca8d9431d1881eb5",
    regNumber: "3588102454",
    name: "주식회사 에이피그린",
    cluster: "전문, 과학 및 기술서비스업",
    subCluster: "신재생에너지 연구개발업",
    incharge: "",
    completedDataNumber: 113,
    newzenTransferredDataNumber: 113,
    totalDataNumber: 113,
    isAccountingConfirmed: false,
  },
  {
    id: "653720e8bfbd844c17e478b8",
    regNumber: "4878703087",
    name: "주식회사 에잇핸즈컴퍼니",
    cluster: "도매 및 소매업",
    subCluster: "화장품 및 화장품용 도매",
    incharge: "",
    completedDataNumber: 52,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 52,
    isAccountingConfirmed: false,
  },
  {
    id: "658d1764e177437299c66cc5",
    regNumber: "2398103415",
    name: "주식회사 에코카우",
    cluster: "정보통신업",
    subCluster: "응용소프트웨어 개발 및 공급업",
    incharge: "",
    completedDataNumber: 14,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 14,
    isAccountingConfirmed: false,
  },
  {
    id: "66680764f11886253d268068",
    regNumber: "4058803141",
    name: "주식회사 엑스업",
    cluster: "제조업",
    subCluster: "그 외 기타 특수 목적용 기계 제조업",
    incharge: "",
    completedDataNumber: 31,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 31,
    isAccountingConfirmed: false,
  },
  {
    id: "653772489aed620ae7d197b6",
    regNumber: "2968802970",
    name: "주식회사 위시스트",
    incharge: "",
    completedDataNumber: 11,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 11,
    isAccountingConfirmed: false,
  },
  {
    id: "650a7d43ca8f634d0b00c28a",
    regNumber: "8828602461",
    name: "주식회사 위웃",
    incharge: "",
    completedDataNumber: 5,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 5,
    isAccountingConfirmed: false,
  },
  {
    id: "64787c2b711b7e0031249b94",
    regNumber: "6448102544",
    name: "주식회사 인더닥터",
    incharge: "",
    completedDataNumber: 55,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 55,
    isAccountingConfirmed: false,
  },
  {
    id: "62c5ec401bce354c47621644",
    regNumber: "2468100740",
    name: "주식회사 자버",
    cluster: "정보통신업",
    subCluster: "소프트웨어 개발 및 공급",
    incharge: "",
    completedDataNumber: 135,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 135,
    isAccountingConfirmed: false,
  },
  {
    id: "6480181a7ff5157daac5a963",
    regNumber: "1878602667",
    name: "주식회사 저스트빌더",
    cluster: "서비스업",
    subCluster: "광고 및 광고 대행업",
    incharge: "",
    completedDataNumber: 173,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 173,
    isAccountingConfirmed: false,
  },
  {
    id: "647810d9711b7e00312350b6",
    regNumber: "3538602717",
    name: "주식회사 제로폴",
    cluster: "전문, 과학 및 기술서비스업",
    subCluster: "환경공학 연구개발업",
    incharge: "",
    completedDataNumber: 49,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 49,
    isAccountingConfirmed: false,
  },
  {
    id: "646d7c114e8af11d3b4170a8",
    regNumber: "8188702773",
    name: "주식회사 젤리게임즈",
    cluster: "정보통신업",
    subCluster: "게임 소프트웨어",
    incharge: "",
    completedDataNumber: 59,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 59,
    isAccountingConfirmed: false,
  },
  {
    id: "648852c4a2b2100b11aef832",
    regNumber: "6628102727",
    name: "주식회사 천년식향",
    incharge: "",
    completedDataNumber: 47,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 47,
    isAccountingConfirmed: false,
  },
  {
    id: "663d5499af918638a367116d",
    regNumber: "1748802985",
    name: "주식회사 케이엔씨글로벌",
    incharge: "",
    completedDataNumber: 3,
    newzenTransferredDataNumber: 3,
    totalDataNumber: 3,
    isAccountingConfirmed: false,
  },
  {
    id: "663db126a9fdc352360831bb",
    regNumber: "6618103136",
    name: "주식회사 쿠즈코퍼레이션",
    incharge: "",
    completedDataNumber: 74,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 74,
    isAccountingConfirmed: false,
  },
  {
    id: "64882f2b9718485b56414eda",
    regNumber: "7928602436",
    name: "주식회사 텅스텐에이아이",
    cluster: "정보통신업",
    subCluster: "데이터베이스 및 온라인 정보 제공업",
    incharge: "",
    completedDataNumber: 2,
    newzenTransferredDataNumber: 2,
    totalDataNumber: 2,
    isAccountingConfirmed: false,
  },
  {
    id: "640854b009bf056c5cd4abe2",
    regNumber: "5858101173",
    name: "주식회사 파이어볼트",
    cluster: "정보통신업",
    subCluster: "전자상거래업",
    incharge: "",
    completedDataNumber: 167,
    newzenTransferredDataNumber: 80,
    totalDataNumber: 167,
    isAccountingConfirmed: false,
  },
  {
    id: "6476a3f6ca8d9431d187e8f1",
    regNumber: "6938102721",
    name: "주식회사 파일러니어",
    incharge: "",
    completedDataNumber: 95,
    newzenTransferredDataNumber: 70,
    totalDataNumber: 95,
    isAccountingConfirmed: false,
  },
  {
    id: "64bd2b13b8a1da192b1664cb",
    regNumber: "5628701978",
    name: "주식회사 파킹유니언",
    cluster: "제조업",
    subCluster: "주차관제장치",
    incharge: "",
    completedDataNumber: 87,
    newzenTransferredDataNumber: 87,
    totalDataNumber: 87,
    isAccountingConfirmed: false,
  },
  {
    id: "664dac7e5ba06c0272b1a989",
    regNumber: "1628601204",
    name: "주식회사 프리그로우",
    cluster: "정보통신업",
    subCluster: "응용 소프트웨어 개발 및 공급업",
    incharge: "",
    completedDataNumber: 285,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 285,
    isAccountingConfirmed: true,
  },
  {
    id: "6482931d9718485b56365c7c",
    regNumber: "6978102908",
    name: "주식회사 프릿",
    cluster: "정보통신업",
    subCluster: "소프트웨어 제작 및 공급업",
    incharge: "",
    completedDataNumber: 15,
    newzenTransferredDataNumber: 12,
    totalDataNumber: 15,
    isAccountingConfirmed: false,
  },
  {
    id: "664c2a225ba06c0272aa65af",
    regNumber: "4568603015",
    name: "주식회사 플렉티",
    cluster: "정보통신업",
    subCluster: "컴퓨터 시스템 통합 자문 및 구축 서비스",
    incharge: "",
    completedDataNumber: 24,
    newzenTransferredDataNumber: 24,
    totalDataNumber: 24,
    isAccountingConfirmed: false,
  },
  {
    id: "63d10f0131bf81120cedb994",
    regNumber: "5678702157",
    name: "주식회사 피매치(PMATCH Inc.)",
    cluster: "서비스업",
    subCluster: "자연과학 및 공학 융합 연구개발업",
    incharge: "",
    completedDataNumber: 25,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 25,
    isAccountingConfirmed: false,
  },
  {
    id: "641c190ae869eb1e0b5de4b4",
    regNumber: "8178103030",
    name: "주식회사 하이브파이브",
    cluster: "정보통신업",
    subCluster: "전자상거래 소매 중개업",
    incharge: "",
    completedDataNumber: 34,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 34,
    isAccountingConfirmed: false,
  },
  {
    id: "66c6aaa39573631cffd758d0",
    regNumber: "8668603207",
    name: "주식회사 호미에이아이",
    cluster: "정보통신업",
    subCluster: "응용 소프트웨어 개발 및 공급업",
    incharge: "",
    completedDataNumber: 22,
    newzenTransferredDataNumber: 22,
    totalDataNumber: 22,
    isAccountingConfirmed: false,
  },
  {
    id: "65cdad82b74c7e065ef288d1",
    regNumber: "4408702890",
    name: "주식회사스누모",
    cluster: "교육서비스업",
    subCluster: "교육관련 자문 및 평가업",
    incharge: "",
    completedDataNumber: 19,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 19,
    isAccountingConfirmed: false,
  },
  {
    id: "64ba319c7a7ba173dcf55cb4",
    regNumber: "4728702524",
    name: "주식회사시엑스알",
    incharge: "",
    completedDataNumber: 29,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 29,
    isAccountingConfirmed: false,
  },
  {
    id: "64ec50c542336672417a5d09",
    regNumber: "6388702880",
    name: "주식회사젠아이피(GenIP Co.,Ltd.)",
    incharge: "",
    completedDataNumber: 18,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 18,
    isAccountingConfirmed: false,
  },
  {
    id: "632a841f7bdb802fce566b07",
    regNumber: "8998602362",
    name: "주식회사토기",
    incharge: "",
    completedDataNumber: 135,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 135,
    isAccountingConfirmed: false,
  },
  {
    id: "66a5c92f84c62040f152f537",
    regNumber: "8418602403",
    name: "큐폴라",
    incharge: "",
    completedDataNumber: 137,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 137,
    isAccountingConfirmed: false,
  },
  {
    id: "63a955fb8e80d0087e78015b",
    regNumber: "4028702715",
    name: "클릭앤라이드",
    incharge: "",
    completedDataNumber: 124,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 124,
    isAccountingConfirmed: false,
  },
  {
    id: "6413ffa8d9f0d629326e08f5",
    regNumber: "7828700651",
    name: "키튼플래닛(주)",
    cluster: "제조업",
    subCluster: "기타가정용전기기기",
    incharge: "",
    completedDataNumber: 5,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 5,
    isAccountingConfirmed: false,
  },
  {
    id: "63adbe54917d0968c12e3c81",
    regNumber: "6088702593",
    name: "타이드풀",
    cluster: "정보통신업",
    subCluster: "응용소프트웨어 개발 및 공급업",
    incharge: "",
    completedDataNumber: 215,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 215,
    isAccountingConfirmed: false,
  },
  {
    id: "66719b3bb8d4f51015d048d5",
    regNumber: "7908603287",
    name: "프랙탈컨설팅",
    cluster: "전문과학및기술서비스업",
    subCluster: "경영컨설팅업",
    incharge: "",
    completedDataNumber: 15,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 15,
    isAccountingConfirmed: false,
  },
  {
    id: "666fa52946379f609bada0fa",
    regNumber: "8478602930",
    name: "프리즘미디어웍스(주)",
    incharge: "",
    completedDataNumber: 25,
    newzenTransferredDataNumber: 0,
    totalDataNumber: 25,
    isAccountingConfirmed: false,
  },
];

export const SAMPLE_CARDBUY_DATA: CardBuy[] = [
  {
    id: "67095d23983ba70fd32566df",
    aprvDt: "2024-09-02",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "거래처 01-01",
    splCft: 12728,
    vaTxamt: 1272,
    accSplCft: 12728,
    accVaTxamt: 1272,
    tip: 0,
    totaTrsAmt: 14000,
    bmanClNm: "일반과세자",
    bcNm: "일반음식점업",
    tfbNm: "한식",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566dd",
    aprvDt: "2024-09-03",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "거래처 01-02",
    splCft: 10000,
    vaTxamt: 1000,
    accSplCft: 10000,
    accVaTxamt: 1000,
    tip: 0,
    totaTrsAmt: 11000,
    bmanClNm: "일반과세자",
    bcNm: "도매 및 소매업",
    tfbNm: "공구, 철물",
    tfbCd: "514361",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566d9",
    aprvDt: "2024-09-03",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "거래처 01-03",
    splCft: 12728,
    vaTxamt: 1272,
    accSplCft: 12728,
    accVaTxamt: 1272,
    tip: 0,
    totaTrsAmt: 14000,
    bmanClNm: "일반과세자",
    bcNm: "일반음식점업",
    tfbNm: "한식",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566db",
    aprvDt: "2024-09-03",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "거래처 01-04",
    splCft: 8200,
    vaTxamt: 820,
    accSplCft: 8200,
    accVaTxamt: 820,
    tip: 0,
    totaTrsAmt: 9020,
    bmanClNm: "일반과세자",
    bcNm: "운수업",
    tfbNm: "택배업",
    tfbCd: "630901",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "824",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566de",
    aprvDt: "2024-09-03",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "거래처 01-05",
    splCft: 92728,
    vaTxamt: 9272,
    accSplCft: 92728,
    accVaTxamt: 9272,
    tip: 0,
    totaTrsAmt: 102000,
    bmanClNm: "일반과세자",
    bcNm: "음식점업",
    tfbNm: "한식",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566da",
    aprvDt: "2024-09-03",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "거래처 01-06",
    splCft: 2728,
    vaTxamt: 272,
    accSplCft: 2728,
    accVaTxamt: 272,
    tip: 0,
    totaTrsAmt: 3000,
    bmanClNm: "법인사업자",
    bcNm: "통신업",
    tfbNm: "부가통신업",
    tfbCd: "724000",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566dc",
    aprvDt: "2024-09-03",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "거래처 01-07",
    splCft: 10728,
    vaTxamt: 1072,
    accSplCft: 10728,
    accVaTxamt: 1072,
    tip: 0,
    totaTrsAmt: 11800,
    bmanClNm: "법인사업자",
    bcNm: "금융 및 보험업",
    tfbNm: "전자지급결제대행",
    tfbCd: "671900",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566d4",
    aprvDt: "2024-09-04",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "거래처 01-07",
    splCft: 1800,
    vaTxamt: 180,
    accSplCft: 1800,
    accVaTxamt: 180,
    tip: 0,
    totaTrsAmt: 1980,
    bmanClNm: "일반과세자",
    bcNm: "제조",
    tfbNm: "산업기계.전기.자동제어",
    tfbCd: "331201",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566d6",
    aprvDt: "2024-09-04",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "거래처 01-08",
    splCft: 5000,
    vaTxamt: 500,
    accSplCft: 5000,
    accVaTxamt: 500,
    tip: 0,
    totaTrsAmt: 5500,
    bmanClNm: "일반과세자",
    bcNm: "제조업",
    tfbNm: "금속용접",
    tfbCd: "289201",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566d5",
    aprvDt: "2024-09-04",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "거래처 01-09",
    splCft: 4364,
    vaTxamt: 436,
    accSplCft: 4364,
    accVaTxamt: 436,
    tip: 0,
    totaTrsAmt: 4800,
    bmanClNm: "일반과세자",
    bcNm: "도매 및 소매업",
    tfbNm: "편의점",
    tfbCd: "521992",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566d7",
    aprvDt: "2024-09-04",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "거래처 01-10",
    splCft: 6819,
    vaTxamt: 681,
    accSplCft: 6819,
    accVaTxamt: 681,
    tip: 0,
    totaTrsAmt: 7500,
    bmanClNm: "일반과세자",
    bcNm: "음식점업",
    tfbNm: "커피",
    tfbCd: "552303",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566d8",
    aprvDt: "2024-09-04",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "거래처 01-11",
    splCft: 6364,
    vaTxamt: 636,
    accSplCft: 6364,
    accVaTxamt: 636,
    tip: 0,
    totaTrsAmt: 7000,
    bmanClNm: "법인사업자",
    bcNm: "음식업",
    tfbNm: "한식점업",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566d3",
    aprvDt: "2024-09-04",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "거래처 01-12",
    splCft: 34800,
    vaTxamt: 3480,
    accSplCft: 34800,
    accVaTxamt: 3480,
    tip: 0,
    totaTrsAmt: 38280,
    bmanClNm: "일반과세자",
    bcNm: "제조",
    tfbNm: "산업기계.전기.자동제어",
    tfbCd: "331201",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566d0",
    aprvDt: "2024-09-05",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "거래처 01-13",
    splCft: 6364,
    vaTxamt: 636,
    accSplCft: 6364,
    accVaTxamt: 636,
    tip: 0,
    totaTrsAmt: 7000,
    bmanClNm: "일반과세자",
    bcNm: "일반음식점업",
    tfbNm: "한식",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566d1",
    aprvDt: "2024-09-05",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "거래처 01-14",
    splCft: 2000,
    vaTxamt: 200,
    accSplCft: 2000,
    accVaTxamt: 200,
    tip: 0,
    totaTrsAmt: 2200,
    bmanClNm: "일반과세자",
    bcNm: "제조",
    tfbNm: "산업기계.전기.자동제어",
    tfbCd: "331201",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566d2",
    aprvDt: "2024-09-05",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "거래처 01-15",
    splCft: 45455,
    vaTxamt: 4545,
    accSplCft: 45455,
    accVaTxamt: 4545,
    tip: 0,
    totaTrsAmt: 50000,
    bmanClNm: "법인사업자",
    bcNm: "서비스업",
    tfbNm: "신용카드결제대행서비스업",
    tfbCd: "749921",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566cf",
    aprvDt: "2024-09-06",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "거래처 01-16",
    splCft: 4100,
    vaTxamt: 410,
    accSplCft: 4100,
    accVaTxamt: 410,
    tip: 0,
    totaTrsAmt: 4510,
    bmanClNm: "일반과세자",
    bcNm: "운수업",
    tfbNm: "택배업",
    tfbCd: "630901",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "824",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566ce",
    aprvDt: "2024-09-06",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "거래처 01-17",
    splCft: 12728,
    vaTxamt: 1272,
    accSplCft: 12728,
    accVaTxamt: 1272,
    tip: 0,
    totaTrsAmt: 14000,
    bmanClNm: "일반과세자",
    bcNm: "일반음식점업",
    tfbNm: "한식",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566cd",
    aprvDt: "2024-09-06",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "거래처 01-18",
    splCft: 14455,
    vaTxamt: 1445,
    accSplCft: 14455,
    accVaTxamt: 1445,
    tip: 0,
    totaTrsAmt: 15900,
    bmanClNm: "법인사업자",
    bcNm: "서비스",
    tfbNm: "전자금융업",
    tfbCd: "724000",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566cb",
    aprvDt: "2024-09-07",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "거래처 01-19",
    splCft: 33637,
    vaTxamt: 3363,
    accSplCft: 33637,
    accVaTxamt: 3363,
    tip: 0,
    totaTrsAmt: 37000,
    bmanClNm: "일반과세자",
    bcNm: "음식점업",
    tfbNm: "일반 음식점업",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566cc",
    aprvDt: "2024-09-07",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "거래처 01-20",
    splCft: 3000,
    vaTxamt: 300,
    accSplCft: 3000,
    accVaTxamt: 300,
    tip: 0,
    totaTrsAmt: 3300,
    bmanClNm: "일반과세자",
    bcNm: "운수업",
    tfbNm: "택배업",
    tfbCd: "630901",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "824",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566ca",
    aprvDt: "2024-09-08",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "구도일한강신도시주유소(주)",
    splCft: 72728,
    vaTxamt: 7272,
    accSplCft: 80000,
    accVaTxamt: 0,
    tip: 0,
    totaTrsAmt: 80000,
    bmanClNm: "법인사업자",
    bcNm: "도매 및 소매업",
    tfbNm: "운송장비용 주유소 운영업",
    tfbCd: "505001",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "822",
    isVatDeduction: false,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566c7",
    aprvDt: "2024-09-09",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "(주)광동유통단양하주유소",
    splCft: 72728,
    vaTxamt: 7272,
    accSplCft: 80000,
    accVaTxamt: 0,
    tip: 0,
    totaTrsAmt: 80000,
    bmanClNm: "법인사업자",
    bcNm: "소매",
    tfbNm: "주유소",
    tfbCd: "505001",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "822",
    isVatDeduction: false,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566c9",
    aprvDt: "2024-09-09",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "양촌리 아구",
    splCft: 37273,
    vaTxamt: 3727,
    accSplCft: 37273,
    accVaTxamt: 3727,
    tip: 0,
    totaTrsAmt: 41000,
    bmanClNm: "일반과세자",
    bcNm: "음식점업",
    tfbNm: "한식",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566c0",
    aprvDt: "2024-09-09",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "임청옥",
    splCft: 60000,
    vaTxamt: 0,
    accSplCft: 60000,
    accVaTxamt: 0,
    tip: 0,
    totaTrsAmt: 60000,
    bmanClNm: "간이과세자",
    bcNm: "음식점업",
    tfbNm: "한식 일반 음식점업",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "간이불공제",
    accountCode: "811",
    isVatDeduction: false,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566c1",
    aprvDt: "2024-09-09",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "주식회사 에스씨케이컴퍼니",
    splCft: 4455,
    vaTxamt: 445,
    accSplCft: 4455,
    accVaTxamt: 445,
    tip: 0,
    totaTrsAmt: 4900,
    bmanClNm: "법인사업자",
    bcNm: "도매 ,소매",
    tfbNm: "커피및 관련용품, 통신판매",
    tfbCd: "512273",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566c2",
    aprvDt: "2024-09-09",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "(주)봄푸드서비스(봄푸드맛집)",
    splCft: 6364,
    vaTxamt: 636,
    accSplCft: 6364,
    accVaTxamt: 636,
    tip: 0,
    totaTrsAmt: 7000,
    bmanClNm: "법인사업자",
    bcNm: "음식업",
    tfbNm: "한식점업",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566c5",
    aprvDt: "2024-09-09",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "(주)엘지유플러스",
    splCft: 61955,
    vaTxamt: 6195,
    accSplCft: 61955,
    accVaTxamt: 6195,
    tip: 0,
    totaTrsAmt: 68150,
    bmanClNm: "법인사업자",
    bcNm: "출판, 영상, 방송통신 및 정보서비스업",
    tfbNm: "유선통신업",
    tfbCd: "642001",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "831",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566c6",
    aprvDt: "2024-09-09",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "김포양촌석모 1186",
    splCft: 4100,
    vaTxamt: 410,
    accSplCft: 4100,
    accVaTxamt: 410,
    tip: 0,
    totaTrsAmt: 4510,
    bmanClNm: "일반과세자",
    bcNm: "운수업",
    tfbNm: "택배업",
    tfbCd: "630901",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "824",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566c8",
    aprvDt: "2024-09-09",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "(주)엘지유플러스",
    splCft: 61955,
    vaTxamt: 6195,
    accSplCft: 61955,
    accVaTxamt: 6195,
    tip: 0,
    totaTrsAmt: 68150,
    bmanClNm: "법인사업자",
    bcNm: "출판, 영상, 방송통신 및 정보서비스업",
    tfbNm: "유선통신업",
    tfbCd: "642001",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "831",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566c3",
    aprvDt: "2024-09-09",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "주식회사 에스씨케이컴퍼니",
    splCft: 11091,
    vaTxamt: 1109,
    accSplCft: 11091,
    accVaTxamt: 1109,
    tip: 0,
    totaTrsAmt: 12200,
    bmanClNm: "법인사업자",
    bcNm: "도매 ,소매",
    tfbNm: "커피및 관련용품, 통신판매",
    tfbCd: "512273",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566c4",
    aprvDt: "2024-09-09",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "한국정보통신(주)",
    splCft: 26100,
    vaTxamt: 2610,
    accSplCft: 26100,
    accVaTxamt: 2610,
    tip: 0,
    totaTrsAmt: 28710,
    bmanClNm: "법인사업자",
    bcNm: "통신업",
    tfbNm: "부가통신업",
    tfbCd: "724000",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566be",
    aprvDt: "2024-09-10",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "삼구공구",
    splCft: 16500,
    vaTxamt: 1650,
    accSplCft: 16500,
    accVaTxamt: 1650,
    tip: 0,
    totaTrsAmt: 18150,
    bmanClNm: "일반과세자",
    bcNm: "도매 및 소매업",
    tfbNm: "공구, 철물",
    tfbCd: "514361",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566bf",
    aprvDt: "2024-09-10",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "호박한식뷔페",
    splCft: 12728,
    vaTxamt: 1272,
    accSplCft: 12728,
    accVaTxamt: 1272,
    tip: 0,
    totaTrsAmt: 14000,
    bmanClNm: "일반과세자",
    bcNm: "일반음식점업",
    tfbNm: "한식",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566bd",
    aprvDt: "2024-09-11",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "호박한식뷔페",
    splCft: 12728,
    vaTxamt: 1272,
    accSplCft: 12728,
    accVaTxamt: 1272,
    tip: 0,
    totaTrsAmt: 14000,
    bmanClNm: "일반과세자",
    bcNm: "일반음식점업",
    tfbNm: "한식",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566bc",
    aprvDt: "2024-09-12",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "엔에이치엔케이씨피 주식회사",
    splCft: 28182,
    vaTxamt: 2818,
    accSplCft: 28182,
    accVaTxamt: 2818,
    tip: 0,
    totaTrsAmt: 31000,
    bmanClNm: "법인사업자",
    bcNm: "서비스",
    tfbNm: "전자금융업",
    tfbCd: "724000",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566bb",
    aprvDt: "2024-09-12",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "주식회사 우아한형제들",
    splCft: 28182,
    vaTxamt: 2818,
    accSplCft: 28182,
    accVaTxamt: 2818,
    tip: 0,
    totaTrsAmt: 31000,
    bmanClNm: "법인사업자",
    bcNm: "영상, 방송통신 및 정보서비스업",
    tfbNm: "데이터베이스 및 온라인정보 제공업,그외 기타 정보서비스업",
    tfbCd: "724000",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566ba",
    aprvDt: "2024-09-13",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "호박한식뷔페",
    splCft: 12728,
    vaTxamt: 1272,
    accSplCft: 12728,
    accVaTxamt: 1272,
    tip: 0,
    totaTrsAmt: 14000,
    bmanClNm: "일반과세자",
    bcNm: "일반음식점업",
    tfbNm: "한식",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566b8",
    aprvDt: "2024-09-14",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "짬뽕지존 김포구래점",
    splCft: 24546,
    vaTxamt: 2454,
    accSplCft: 24546,
    accVaTxamt: 2454,
    tip: 0,
    totaTrsAmt: 27000,
    bmanClNm: "일반과세자",
    bcNm: "음식",
    tfbNm: "중식",
    tfbCd: "552102",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566b9",
    aprvDt: "2024-09-14",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "김포양촌석모 1186",
    splCft: 1500,
    vaTxamt: 150,
    accSplCft: 1500,
    accVaTxamt: 150,
    tip: 0,
    totaTrsAmt: 1650,
    bmanClNm: "일반과세자",
    bcNm: "운수업",
    tfbNm: "택배업",
    tfbCd: "630901",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "824",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566b6",
    aprvDt: "2024-09-15",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "전주미콩나물국밥",
    splCft: 14091,
    vaTxamt: 1409,
    accSplCft: 14091,
    accVaTxamt: 1409,
    tip: 0,
    totaTrsAmt: 15500,
    bmanClNm: "일반과세자",
    bcNm: "음식점업",
    tfbNm: "한식",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566b7",
    aprvDt: "2024-09-15",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "메가엠지씨커피 김포양촌산업단지점",
    splCft: 728,
    vaTxamt: 72,
    accSplCft: 728,
    accVaTxamt: 72,
    tip: 0,
    totaTrsAmt: 800,
    bmanClNm: "일반과세자",
    bcNm: "음식점업",
    tfbNm: "카페",
    tfbCd: "552303",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566b5",
    aprvDt: "2024-09-17",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "주식회사 디에스",
    splCft: 27273,
    vaTxamt: 2727,
    accSplCft: 30000,
    accVaTxamt: 0,
    tip: 0,
    totaTrsAmt: 30000,
    bmanClNm: "법인사업자",
    bcNm: "소매",
    tfbNm: "주유소",
    tfbCd: "505001",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "822",
    isVatDeduction: false,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566b1",
    aprvDt: "2024-09-19",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "엔에이치엔케이씨피 주식회사",
    splCft: 4546,
    vaTxamt: 454,
    accSplCft: 4546,
    accVaTxamt: 454,
    tip: 0,
    totaTrsAmt: 5000,
    bmanClNm: "법인사업자",
    bcNm: "서비스",
    tfbNm: "전자금융업",
    tfbCd: "724000",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566b3",
    aprvDt: "2024-09-19",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "엔에이치엔케이씨피 주식회사",
    splCft: 8182,
    vaTxamt: 818,
    accSplCft: 8182,
    accVaTxamt: 818,
    tip: 0,
    totaTrsAmt: 9000,
    bmanClNm: "법인사업자",
    bcNm: "서비스",
    tfbNm: "전자금융업",
    tfbCd: "724000",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566b0",
    aprvDt: "2024-09-19",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "호박한식뷔페",
    splCft: 25455,
    vaTxamt: 2545,
    accSplCft: 25455,
    accVaTxamt: 2545,
    tip: 0,
    totaTrsAmt: 28000,
    bmanClNm: "일반과세자",
    bcNm: "일반음식점업",
    tfbNm: "한식",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566b2",
    aprvDt: "2024-09-19",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "김포양촌석모 1186",
    splCft: 4100,
    vaTxamt: 410,
    accSplCft: 4100,
    accVaTxamt: 410,
    tip: 0,
    totaTrsAmt: 4510,
    bmanClNm: "일반과세자",
    bcNm: "운수업",
    tfbNm: "택배업",
    tfbCd: "630901",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "824",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566b4",
    aprvDt: "2024-09-19",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "엔에이치엔케이씨피 주식회사",
    splCft: 4546,
    vaTxamt: 454,
    accSplCft: 4546,
    accVaTxamt: 454,
    tip: 0,
    totaTrsAmt: 5000,
    bmanClNm: "법인사업자",
    bcNm: "서비스",
    tfbNm: "전자금융업",
    tfbCd: "724000",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566ad",
    aprvDt: "2024-09-20",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "호박한식뷔페",
    splCft: 25455,
    vaTxamt: 2545,
    accSplCft: 25455,
    accVaTxamt: 2545,
    tip: 0,
    totaTrsAmt: 28000,
    bmanClNm: "일반과세자",
    bcNm: "일반음식점업",
    tfbNm: "한식",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566ae",
    aprvDt: "2024-09-20",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "김포양촌석모 1186",
    splCft: 5600,
    vaTxamt: 560,
    accSplCft: 5600,
    accVaTxamt: 560,
    tip: 0,
    totaTrsAmt: 6160,
    bmanClNm: "일반과세자",
    bcNm: "운수업",
    tfbNm: "택배업",
    tfbCd: "630901",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "824",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566af",
    aprvDt: "2024-09-20",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "엔에이치엔케이씨피 주식회사",
    splCft: 4546,
    vaTxamt: 454,
    accSplCft: 4546,
    accVaTxamt: 454,
    tip: 0,
    totaTrsAmt: 5000,
    bmanClNm: "법인사업자",
    bcNm: "서비스",
    tfbNm: "전자금융업",
    tfbCd: "724000",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566a9",
    aprvDt: "2024-09-21",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "김포양촌석모 1186",
    splCft: 1500,
    vaTxamt: 150,
    accSplCft: 1500,
    accVaTxamt: 150,
    tip: 0,
    totaTrsAmt: 1650,
    bmanClNm: "일반과세자",
    bcNm: "운수업",
    tfbNm: "택배업",
    tfbCd: "630901",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "824",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566ab",
    aprvDt: "2024-09-21",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "국민포장",
    splCft: 14000,
    vaTxamt: 1400,
    accSplCft: 14000,
    accVaTxamt: 1400,
    tip: 0,
    totaTrsAmt: 15400,
    bmanClNm: "일반과세자",
    bcNm: "제조",
    tfbNm: "비닐",
    tfbCd: "243000",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566ac",
    aprvDt: "2024-09-21",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "삼구공구",
    splCft: 16000,
    vaTxamt: 1600,
    accSplCft: 16000,
    accVaTxamt: 1600,
    tip: 0,
    totaTrsAmt: 17600,
    bmanClNm: "일반과세자",
    bcNm: "도매 및 소매업",
    tfbNm: "공구, 철물",
    tfbCd: "514361",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566a8",
    aprvDt: "2024-09-21",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "(주)봄푸드서비스(봄푸드맛집)",
    splCft: 6364,
    vaTxamt: 636,
    accSplCft: 6364,
    accVaTxamt: 636,
    tip: 0,
    totaTrsAmt: 7000,
    bmanClNm: "법인사업자",
    bcNm: "음식업",
    tfbNm: "한식점업",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566aa",
    aprvDt: "2024-09-21",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "대성닛블",
    splCft: 2800,
    vaTxamt: 280,
    accSplCft: 2800,
    accVaTxamt: 280,
    tip: 0,
    totaTrsAmt: 3080,
    bmanClNm: "일반과세자",
    bcNm: "도,소매",
    tfbNm: "유공압,배관자재",
    tfbCd: "514366",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "820",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566a6",
    aprvDt: "2024-09-23",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "김포양촌석모 1186",
    splCft: 5100,
    vaTxamt: 510,
    accSplCft: 5100,
    accVaTxamt: 510,
    tip: 0,
    totaTrsAmt: 5610,
    bmanClNm: "일반과세자",
    bcNm: "운수업",
    tfbNm: "택배업",
    tfbCd: "630901",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "824",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566a4",
    aprvDt: "2024-09-23",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "호박한식뷔페",
    splCft: 25455,
    vaTxamt: 2545,
    accSplCft: 25455,
    accVaTxamt: 2545,
    tip: 0,
    totaTrsAmt: 28000,
    bmanClNm: "일반과세자",
    bcNm: "일반음식점업",
    tfbNm: "한식",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566a5",
    aprvDt: "2024-09-23",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "엔에이치엔케이씨피 주식회사",
    splCft: 4546,
    vaTxamt: 454,
    accSplCft: 4546,
    accVaTxamt: 454,
    tip: 0,
    totaTrsAmt: 5000,
    bmanClNm: "법인사업자",
    bcNm: "서비스",
    tfbNm: "전자금융업",
    tfbCd: "724000",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566a7",
    aprvDt: "2024-09-23",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "엔에이치엔케이씨피 주식회사",
    splCft: 4546,
    vaTxamt: 454,
    accSplCft: 4546,
    accVaTxamt: 454,
    tip: 0,
    totaTrsAmt: 5000,
    bmanClNm: "법인사업자",
    bcNm: "서비스",
    tfbNm: "전자금융업",
    tfbCd: "724000",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566a1",
    aprvDt: "2024-09-24",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "구도일한강신도시주유소(주)",
    splCft: 63637,
    vaTxamt: 6363,
    accSplCft: 70000,
    accVaTxamt: 0,
    tip: 0,
    totaTrsAmt: 70000,
    bmanClNm: "법인사업자",
    bcNm: "도매 및 소매업",
    tfbNm: "운송장비용 주유소 운영업",
    tfbCd: "505001",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "822",
    isVatDeduction: false,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566a0",
    aprvDt: "2024-09-24",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "구도일한강신도시주유소(주)",
    splCft: 5455,
    vaTxamt: 545,
    accSplCft: 6000,
    accVaTxamt: 0,
    tip: 0,
    totaTrsAmt: 6000,
    bmanClNm: "법인사업자",
    bcNm: "도매 및 소매업",
    tfbNm: "운송장비용 주유소 운영업",
    tfbCd: "505001",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "822",
    isVatDeduction: false,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566a3",
    aprvDt: "2024-09-24",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "대성석유(주) 김포한강신도시 주유소",
    splCft: 63637,
    vaTxamt: 6363,
    accSplCft: 70000,
    accVaTxamt: 0,
    tip: 0,
    totaTrsAmt: 70000,
    bmanClNm: "법인사업자",
    bcNm: "도소매",
    tfbNm: "주유소",
    tfbCd: "505001",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "822",
    isVatDeduction: false,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd32566a2",
    aprvDt: "2024-09-24",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "통큰아지매",
    splCft: 25455,
    vaTxamt: 2545,
    accSplCft: 25455,
    accVaTxamt: 2545,
    tip: 0,
    totaTrsAmt: 28000,
    bmanClNm: "일반과세자",
    bcNm: "음식점업",
    tfbNm: "일반 음식점업",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd325669f",
    aprvDt: "2024-09-24",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "(주)이랜드킴스클럽 김포점",
    splCft: 19982,
    vaTxamt: 1998,
    accSplCft: 19982,
    accVaTxamt: 1998,
    tip: 0,
    totaTrsAmt: 21980,
    bmanClNm: "법인사업자",
    bcNm: "도매 및 소매업",
    tfbNm: "슈퍼마켓",
    tfbCd: "521100",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd3256698",
    aprvDt: "2024-09-25",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "안가참숯뒷고기",
    splCft: 33637,
    vaTxamt: 3363,
    accSplCft: 33637,
    accVaTxamt: 3363,
    tip: 0,
    totaTrsAmt: 37000,
    bmanClNm: "일반과세자",
    bcNm: "음식",
    tfbNm: "한식",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd3256699",
    aprvDt: "2024-09-25",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "시카고모텔",
    splCft: 54546,
    vaTxamt: 5454,
    accSplCft: 60000,
    accVaTxamt: 0,
    tip: 0,
    totaTrsAmt: 60000,
    bmanClNm: "일반과세자",
    bcNm: "숙박업",
    tfbNm: "모텔",
    tfbCd: "551002",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "812",
    isVatDeduction: false,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd325669e",
    aprvDt: "2024-09-25",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "대보유통(주)",
    splCft: 5455,
    vaTxamt: 545,
    accSplCft: 5455,
    accVaTxamt: 545,
    tip: 0,
    totaTrsAmt: 6000,
    bmanClNm: "법인사업자",
    bcNm: "음식",
    tfbNm: "고속도로휴게소",
    tfbCd: "552305",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd3256697",
    aprvDt: "2024-09-25",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "황금성",
    splCft: 16364,
    vaTxamt: 1636,
    accSplCft: 16364,
    accVaTxamt: 1636,
    tip: 0,
    totaTrsAmt: 18000,
    bmanClNm: "일반과세자",
    bcNm: "음식점업",
    tfbNm: "중식 음식점업",
    tfbCd: "552102",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd325669a",
    aprvDt: "2024-09-25",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "대보유통(주 )괴산(마산)휴게소",
    splCft: 6364,
    vaTxamt: 636,
    accSplCft: 6364,
    accVaTxamt: 636,
    tip: 0,
    totaTrsAmt: 7000,
    bmanClNm: "법인사업자",
    bcNm: "음식",
    tfbNm: "고소도로휴게소",
    tfbCd: "552305",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd325669b",
    aprvDt: "2024-09-25",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "하이오아시스(주)",
    splCft: 5819,
    vaTxamt: 581,
    accSplCft: 5819,
    accVaTxamt: 581,
    tip: 0,
    totaTrsAmt: 6400,
    bmanClNm: "법인사업자",
    bcNm: "음식,소매",
    tfbNm: "고속도로휴게소",
    tfbCd: "552305",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd325669d",
    aprvDt: "2024-09-25",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "썰어썰어횟집",
    splCft: 62728,
    vaTxamt: 6272,
    accSplCft: 62728,
    accVaTxamt: 6272,
    tip: 0,
    totaTrsAmt: 69000,
    bmanClNm: "일반과세자",
    bcNm: "음식점업",
    tfbNm: "한식 음식점업",
    tfbCd: "552116",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd325669c",
    aprvDt: "2024-09-25",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "주식회사 에스씨케이컴퍼니",
    splCft: 4819,
    vaTxamt: 481,
    accSplCft: 4819,
    accVaTxamt: 481,
    tip: 0,
    totaTrsAmt: 5300,
    bmanClNm: "법인사업자",
    bcNm: "도매 ,소매",
    tfbNm: "커피및 관련용품, 통신판매",
    tfbCd: "512273",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd3256690",
    aprvDt: "2024-09-26",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "커피명가코앰코",
    splCft: 5000,
    vaTxamt: 500,
    accSplCft: 5000,
    accVaTxamt: 500,
    tip: 0,
    totaTrsAmt: 5500,
    bmanClNm: "일반과세자",
    bcNm: "음식",
    tfbNm: "커피",
    tfbCd: "552303",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd3256695",
    aprvDt: "2024-09-26",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "호박한식뷔페",
    splCft: 12728,
    vaTxamt: 1272,
    accSplCft: 12728,
    accVaTxamt: 1272,
    tip: 0,
    totaTrsAmt: 14000,
    bmanClNm: "일반과세자",
    bcNm: "일반음식점업",
    tfbNm: "한식",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd3256696",
    aprvDt: "2024-09-26",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "울산남구야음7",
    splCft: 2000,
    vaTxamt: 200,
    accSplCft: 2000,
    accVaTxamt: 200,
    tip: 0,
    totaTrsAmt: 2200,
    bmanClNm: "일반과세자",
    bcNm: "운수업",
    tfbNm: "택배",
    tfbCd: "630901",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "824",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd3256691",
    aprvDt: "2024-09-26",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "한국도로공사 문경(양평방향)주유소",
    splCft: 63637,
    vaTxamt: 6363,
    accSplCft: 70000,
    accVaTxamt: 0,
    tip: 0,
    totaTrsAmt: 70000,
    bmanClNm: "법인사업자",
    bcNm: "소매업",
    tfbNm: "주유소",
    tfbCd: "505001",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "822",
    isVatDeduction: false,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd3256692",
    aprvDt: "2024-09-26",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "주식회사 에스씨케이컴퍼니",
    splCft: 9546,
    vaTxamt: 954,
    accSplCft: 9546,
    accVaTxamt: 954,
    tip: 0,
    totaTrsAmt: 10500,
    bmanClNm: "법인사업자",
    bcNm: "도매 ,소매",
    tfbNm: "커피및 관련용품, 통신판매",
    tfbCd: "512273",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd3256693",
    aprvDt: "2024-09-26",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "샵(#)121",
    splCft: 6819,
    vaTxamt: 681,
    accSplCft: 7500,
    accVaTxamt: 0,
    tip: 0,
    totaTrsAmt: 7500,
    bmanClNm: "간이과세자",
    bcNm: "음식",
    tfbNm: "커피,다류",
    tfbCd: "552303",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: false,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd3256694",
    aprvDt: "2024-09-26",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "본죽",
    splCft: 24546,
    vaTxamt: 2454,
    accSplCft: 24546,
    accVaTxamt: 2454,
    tip: 0,
    totaTrsAmt: 27000,
    bmanClNm: "일반과세자",
    bcNm: "음식",
    tfbNm: "한식(죽)",
    tfbCd: "552107",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd325668e",
    aprvDt: "2024-09-27",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "김포양촌석모 1186",
    splCft: 10200,
    vaTxamt: 1020,
    accSplCft: 10200,
    accVaTxamt: 1020,
    tip: 0,
    totaTrsAmt: 11220,
    bmanClNm: "일반과세자",
    bcNm: "운수업",
    tfbNm: "택배업",
    tfbCd: "630901",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "824",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd325668c",
    aprvDt: "2024-09-27",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269523412891",
    mrntTxprNm: "김포양촌석모 1186",
    splCft: 3000,
    vaTxamt: 300,
    accSplCft: 3000,
    accVaTxamt: 300,
    tip: 0,
    totaTrsAmt: 3300,
    bmanClNm: "일반과세자",
    bcNm: "운수업",
    tfbNm: "택배업",
    tfbCd: "630901",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "824",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd325668d",
    aprvDt: "2024-09-27",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "엉클kun커피하우스",
    splCft: 12728,
    vaTxamt: 1272,
    accSplCft: 12728,
    accVaTxamt: 1272,
    tip: 0,
    totaTrsAmt: 14000,
    bmanClNm: "일반과세자",
    bcNm: "음식점업",
    tfbNm: "일반음식",
    tfbCd: "552104",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd325668f",
    aprvDt: "2024-09-27",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "케이에이치에너지(주) 직영 의왕휴게소(의왕방향)",
    splCft: 5000,
    vaTxamt: 500,
    accSplCft: 5000,
    accVaTxamt: 500,
    tip: 0,
    totaTrsAmt: 5500,
    bmanClNm: "법인사업자",
    bcNm: "도매 및 소매업",
    tfbNm: "잡화",
    tfbCd: "513992",
    ddcYnNm: "공제",
    vatDdcClNm: null,
    accountCode: "830",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd325668b",
    aprvDt: "2024-09-28",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "(주)봄푸드서비스(봄푸드맛집)",
    splCft: 6364,
    vaTxamt: 636,
    accSplCft: 6364,
    accVaTxamt: 636,
    tip: 0,
    totaTrsAmt: 7000,
    bmanClNm: "법인사업자",
    bcNm: "음식업",
    tfbNm: "한식점업",
    tfbCd: "552101",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
  {
    id: "67095d23983ba70fd325668a",
    aprvDt: "2024-09-29",
    crcmClNm: "(주)국민은행",
    busnCrdCardNoEncCntn: "5585269540527853",
    mrntTxprNm: "주식회사 우아한형제들",
    splCft: 9091,
    vaTxamt: 909,
    accSplCft: 9091,
    accVaTxamt: 909,
    tip: 0,
    totaTrsAmt: 10000,
    bmanClNm: "법인사업자",
    bcNm: "영상, 방송통신 및 정보서비스업",
    tfbNm: "데이터베이스 및 온라인정보 제공업,그외 기타 정보서비스업",
    tfbCd: "724000",
    ddcYnNm: "불공제",
    vatDdcClNm: "선택불공제",
    accountCode: "811",
    isVatDeduction: true,
    isAccountingConfirmed: null,
    lastModifiedDate: null,
  },
];
